import React, { useState } from 'react';
import '../styles/leaderboard.css';
import { useLeaderboard } from '../hooks/useLeaderboard';
import { useWalletBalance } from '../hooks/useWalletBalance';
import { useGameState } from '../hooks/useGameState';
import { useAttempts } from '../hooks/useAttempts';

interface LeaderboardEntry {
  rank: number;
  name: string;
  round?: number;
  startDate?: string;
  endDate?: string;
  attempts?: number;
  bountyUSD?: string;
  bountyTokens?: string;
  bountySol?: number;
}

export default function Leaderboard() {
  const [activeTab, setActiveTab] = useState<'attempts' | 'rounds'>('attempts');
  const { leaderboard, loading: leaderboardLoading } = useLeaderboard();
  const { gameState, loading: gameStateLoading } = useGameState();
  const { totalAttempts } = useAttempts();
  const { solBalance, tokenBalance, totalUsdValue } = useWalletBalance();

  const roundsData: LeaderboardEntry[] = [
    {
      rank: 1,
      name: 'Round 1',
      round: 1,
      startDate: '2025-01-17',
      endDate: '2025-01-17',
      attempts: 48,
      bountyUSD: "$2650",
      bountyTokens: "Round 1 Complete"
    },
    { 
      rank: 2, 
      name: "Round 2", 
      round: 2, 
      startDate: "2025-01-17",
      endDate: "2025-01-18",
      attempts: 201,
      bountyUSD: "Round 2 Complete",
      bountyTokens: "Round 2 Complete"
    },
    { 
      rank: 3, 
      name: "BREK TIME", 
      round: 3, 
      startDate: "2025-02-02",
      endDate: "Active",
      attempts: totalAttempts || 0,
      bountyUSD: `$${totalUsdValue?.toFixed(2) || "0.00"}`,
      bountyTokens: `${tokenBalance?.toFixed(2) || "0"} $BREK`
    },
    { 
      rank: 4, 
      name: "Coming Soon", 
      round: 4, 
      startDate: "TBA",
      endDate: "TBA",
      attempts: 0,
      bountyUSD: "TBA",
      bountyTokens: "TBA"
    },
    { 
      rank: 5, 
      name: "Coming Soon", 
      round: 5, 
      startDate: "TBA",
      endDate: "TBA",
      attempts: 0,
      bountyUSD: "TBA",
      bountyTokens: "TBA"
    }
  ];

  // Transform leaderboard data to match the expected format
  const attemptsData: LeaderboardEntry[] = React.useMemo(() => {
    if (!leaderboard) return [];
    return leaderboard.map((entry, index) => ({
      rank: index + 1,
      name: entry.nickname || entry.publicKey,
      attempts: entry.totalAttempts
    })).slice(0, 10);
  }, [leaderboard]);

  const data = activeTab === 'attempts' ? attemptsData : roundsData;

  if (activeTab === 'attempts' && leaderboardLoading) {
    return <div className="leaderboard">Loading leaderboard data...</div>;
  }

  return (
    <section className="leaderboard-section">
      <h2 className="section-title">Leaderboard</h2>
      <div className="leaderboard">
        <div className="leaderboard-tabs">
          <button 
            className={`leaderboard-tab ${activeTab === 'attempts' ? 'active' : ''}`}
            onClick={() => setActiveTab('attempts')}
          >
            Attempts
          </button>
          <button 
            className={`leaderboard-tab ${activeTab === 'rounds' ? 'active' : ''}`}
            onClick={() => setActiveTab('rounds')}
          >
            Rounds
          </button>
        </div>

        <div className="leaderboard-table">
          <div className={`leaderboard-headers ${activeTab === 'attempts' ? 'attempts-view' : 'rounds-view'}`}>
            {activeTab === 'attempts' ? (
              <>
                <div>Rank</div>
                <div>Player</div>
                <div>Attempts</div>
              </>
            ) : (
              <>
                <div>Game #</div>
                <div>Started</div>
                <div>Ended</div>
                <div>Attempts</div>
                <div>Bounty</div>
              </>
            )}
          </div>

          <div className="leaderboard-list">
            {data.map((entry) => (
              <div key={entry.rank} className={`leaderboard-item nes-container is-rounded ${activeTab === 'attempts' ? 'attempts-view' : 'rounds-view'}`}>
                {activeTab === 'attempts' ? (
                  <>
                    <div className="game-number">{entry.rank}</div>
                    <div className="game-info">{entry.name}</div>
                    <div className="attempts-info">{entry.attempts}</div>
                  </>
                ) : (
                  <>
                    <div className="game-number">{entry.round}</div>
                    <div className="date-info">
                      <span className="label">Started:</span> {entry.startDate}
                    </div>
                    <div className="date-info">
                      <span className="label">Ended:</span> {entry.endDate}
                    </div>
                    <div className="attempts-info">
                      <span className="label">Attempts:</span> {entry.attempts}
                    </div>
                    <div className="bounty-info">
                      <div className="amount">{entry.bountyUSD}</div>
                      <div className="tokens">{entry.bountyTokens}</div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
} 